module.exports = __webpack_public_path__ + "images/category_lp/earphone/store_images/1_fe5c828d076e87be942995393a992b87.png";